import { render, staticRenderFns } from "./Dependencies.vue?vue&type=template&id=32b04354&scoped=true&"
import script from "./Dependencies.vue?vue&type=script&lang=js&"
export * from "./Dependencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b04354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b04354')) {
      api.createRecord('32b04354', component.options)
    } else {
      api.reload('32b04354', component.options)
    }
    module.hot.accept("./Dependencies.vue?vue&type=template&id=32b04354&scoped=true&", function () {
      api.rerender('32b04354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Gantt/Dependencies.vue"
export default component.exports